import React, { useContext, useEffect, useState } from "react";
import "./Default.scss";
import "./DefaultMobile.scss";
import IconKtech from "@icons/IconKtech";
import LstMenu from "@components/lstmenu/LstMenu";
import { ToastContainer } from "react-toastify";
import { useNavigate } from "react-router-dom";
import Loading from "@components/loading/Loading";
import GlobalContext from "@context/GlobalContext";
import IconPerfil from "@icons/IconPerfil";
import UtilServices from "@services/UtilServices";
import useAutenticar from "@hooks/useAutenticar";
import MessageServices from "@services/MessageServices";
import EndPointServices from "@services/ApiServices";
import { useTour } from "@reactour/tour";
import { Tooltip } from "react-tooltip";
import Menu from "./menu/Menu";

const Default = (props) => {
  //variaveis padrões
  const [state, dispatch] = useContext(GlobalContext);
  const navigate = useNavigate();
  const { handleLogout } = useAutenticar();

  //LstMenu
  const [openlstMenu, setOpenLstMenu] = useState(false);
  const [openlstMenuPerfil, setOpenLstMenuPerfil] = useState(false);
  const listPerfil = [
    {
      id: 1,
      desc: UtilServices.primeiraLetraMaiuscula(state.dadosusuario.nome),
      icon: "<i class='fa-solid fa-user'></i>",
      desc2: `Ultimo Acesso: ${UtilServices.convertDataHora(
        state.dadosusuario?.ultimo_acesso,
      )}`,
    },
    {
      id: 2,
      desc: "Sair",
      icon: "<i class='fa-solid fa-right-from-bracket'></i>",
      class: "sair",
    },
  ];

  function handleLstPerfil(item) {
    if (item.id === 2) {
      handleLogout();
    } else {
      MessageServices.ShowWarning("#Em Desenvolvimento!");
    }
  }

  //Regras para funcionar o help para o cliente.
  const { setIsOpen } = useTour();
  useEffect(() => {
    if (
      !state.tourclose[`tour_${props.tpStep}`] &&
      !state?.dadosusuario?.tourclose?.includes(`tour_${props.tpStep}`)
    ) {
      setIsOpen(true);
    }
    if (state.tourclose[`tour_${props.tpStep}`]) {
      setIsOpen(false);
    }
  }, [state]);

  //verifica a sessão
  useEffect(() => {
    const intervalo = setInterval(
      () => {
        EndPointServices.Autentica_VerificaSessao();
      },
      241 * 60 * 1000,
    ); // 4 horas
    return () => clearInterval(intervalo);
  }, []);

  //menu soluções.
  useEffect(() => {
    handleConsultarMenuLateral();
    function handleMouseClick(event) {
      const evento = event.target;
      const eventoString = evento.outerHTML; // transforma em string
      if (!eventoString.includes("clicou-menu")) {
        setOpenLstMenu(false);
        setOpenLstMenuPerfil(false);
      }
    }
    document.addEventListener("mousedown", handleMouseClick);
    return () => {
      document.removeEventListener("mousedown", handleMouseClick);
    };
  }, []);

  async function handleConsultarMenuLateral() {
    let data = {
      id_usuario_guid: state.dadosusuario?.id_usuario_guid,
      id_usuario: state.dadosusuario?.id_usuario,
    };

    var retornoapi = await EndPointServices.Autentica_Menu(data);
    if (retornoapi.Success) {
      let menulateral = handleConstruindoHierarquia(
        retornoapi?.BaseReturn?.LstClasse,
      );

      dispatch({
        type: "SET_MENULATERAL",
        payload: menulateral,
      });
    }
  }
  // Função para montar hierarquia
  function handleConstruindoHierarquia(menus) {
    const tree = {};

    menus.forEach((item) => {
      const [index, ...labelParts] = item.menus.split(" ");
      const levels = index.split(".");
      const label = labelParts.join(" ");
      const disabled = item?.disabled;
      const icon = item?.icon;
      const url = item?.url;
      const title = item?.title;

      let current = tree;

      levels.forEach((level, i) => {
        const key = levels.slice(0, i + 1).join(".");

        if (!current[key]) {
          current[key] = {};
        }

        // Quando for o último nível, adiciona os dados
        if (i === levels.length - 1) {
          current[key] = {
            label,
            url,
            icon,
            disabled,
            title,
          };
        }

        current = current[key];
      });

      // No nível raiz, adiciona o nome do pai com base em Descricao
      const rootLevel = levels[0];
      if (!tree[rootLevel]) {
        tree[rootLevel] = {};
      }
      if (!tree[rootLevel].label) {
        tree[rootLevel].label = item.menupai;
        tree[rootLevel].icon = item.iconpai;
        tree[rootLevel].disabled = item?.disabledpai;
      }
    });

    return tree;
  }

  return (
    <div className="default container lg:pl-[80px]">
      <div className="row">
        <Menu />
        <div
          className="col-6"
          style={{ display: "flex", alignItems: "center", gap: "50px" }}
        >
          <IconKtech
            width="50px"
            height="50px"
            className="default-icon-ktechno"
            onClick={() => {
              navigate("/");
            }}
          />
        </div>
        <div
          className="col-6 perfil"
          style={{
            display: "flex",
            alignItems: "center",
            gap: "5px",
            justifyContent: "flex-end",
          }}
        >
          <IconPerfil />
          <LstMenu
            title=""
            open={openlstMenuPerfil}
            setOpen={setOpenLstMenuPerfil}
            lst={listPerfil}
            width="220px"
            onClick={handleLstPerfil}
          />
        </div>
      </div>
      {props.back && (
        <div>
          <i
            style={{
              fontSize: "18px",
              cursor: "pointer",
              marginTop: "25px",
              color: "var(--color-01)",
            }}
            onClick={() => {
              navigate(-1);
            }}
            className="fa-solid fa-backward-step"
          />
        </div>
      )}
      <div className="icon-default">
        {props.icon}
        <p>{props.title}</p>
      </div>
      <div>{props.children}</div>
      <ToastContainer />
      <Loading color="#c1abff" show={state.loading} />
      {props.tpStep && (
        <div class="help">
          <i
            onClick={() => {
              setIsOpen(true);
            }}
            class="fa-solid fa-question"
          ></i>
        </div>
      )}
      {/* tooltips */}
      <Tooltip
        id="tooltip-001"
        className="default-tooltip"
        style={{ zIndex: 10 }}
      />
      <Tooltip
        id="tooltip-002"
        className="tooltip-002"
        style={{ zIndex: 10 }}
        place="right"
      />
    </div>
  );
};

export default Default;
